/* Mobile navigation click button
---------------------------------------------------*/
$(document).on('click', '.mobile-menu', function(){
	var $this = $(this),
		$navWrapper = $('#nav .mobile-nav-wrapper'),
		$navWrapperHeight = $navWrapper.height(),
		$navWrapperContent = $('#nav ul'),
		$navWrapperContentHeight;
		
	$this.toggleClass('open');

	if ($navWrapperHeight) {
		$navWrapper.css({
			height: 0,
			opacity: 0,
		});
	} else {
		$navWrapperContentHeight = $navWrapperContent.height();
		$navWrapper.css({
			height: $navWrapperContentHeight + 'px',
			opacity: 1
		});
	}
});

if (("standalone" in window.navigator) && window.navigator.standalone) {
	// For iOS fullscreen web apps
	$('body').on('click fastclick', 'a.app-navigation', function(evt) {
		var nextPageURL = $(this).attr('href');
		evt.preventDefault();
		if (nextPageURL != undefined && nextPageURL.substr(0, 1) != '#' && $(this).attr('data-method') == undefined){
			window.location.href = nextPageURL;
		}
	});
}